<template>
  <transition>
    <div class="score flexcenter">
      <div class="modal-inner">
        <div class="score-base flexcenter">
          <button class="modal-close" @click="$emit('close')"></button>
          <div class="score-baseInner">
            <!-- 表題 -->
            <div class="score-title flexstart">
              <span class="lvl-orange font14 mr10">レベル {{ levelNo }} </span>
              <span class="lbold font18">ユニット {{ unitNo }} 「{{ unitTitle }}」: レッスン {{ lessonIndex + 1 }} : {{ path.title }}</span>
            </div>

            <!-- 総合スコア -->
            <div class="score-percent flexcenter lbold">
              <div class="font18">総合スコア</div>
              <div class="textorange"><span class="font40">{{ path.answerRate }}</span><span class="font30">%</span></div>
            </div>

            <!-- スコア詳細 -->
            <div class="score-detail">
              <div class="score-total flexbetween lbold">
                <span class="ok">正解：{{ path.ok }}　</span>
                <span class="ng">不正解：{{ path.ng }}　</span>
                <span class="skip">スキップ：{{ path.skip }}　</span>
                <span class="total">合計：{{ path.count }} / {{ path.total }}</span>
              </div>
              <div class="score-pathsteps">
                <div class="row flexstart" v-for="(row, rowIndex) in scores">
                  <div class="score-pathstep" v-for="(score, scoreIndex) in row">
                    <div v-on:click="showPathstep(scoreIndex + (rowIndex * COLUMN_COUNT))">
                      <div class="step-num font18">
                        <span v-if="score.status === constants.PATHSTEP_STATE_COMPLETED" class="num gone">{{ scoreIndex + 1 + (rowIndex * COLUMN_COUNT) }}</span>
                        <span v-else-if="score.status === constants.PATHSTEP_STATE_IN_PROGRESS" class="num going">{{ scoreIndex + 1 + (rowIndex * COLUMN_COUNT) }}</span>
                        <span v-else-if="score.status === constants.PATHSTEP_STATE_NOT_YET_STARTED" class="num pending">{{ scoreIndex + 1 + (rowIndex * COLUMN_COUNT) }}</span>
                        <span v-if="score.status === constants.PATHSTEP_STATE_COMPLETED" class="status-icon gone"></span>
                        <span v-else-if="score.status === constants.PATHSTEP_STATE_IN_PROGRESS" class="status-icon going"></span>
                        <span v-else-if="score.status === constants.PATHSTEP_STATE_NOT_YET_STARTED" class="status-icon pending"></span>
                      </div>
                      <ul class="score-list">
                        <li class="flexbetween"><span class="ok"></span><span>{{ score.ok }}</span></li>
                        <li class="flexbetween"><span class="ng"></span><span>{{ score.ng }}</span></li>
                        <li class="flexbetween"><span class="skip"></span><span>{{ score.skip }}</span></li>
                        <li class="total"><span>{{ score.count }} / {{ score.total }}</span></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as mixinConstants from '@/mixin/constants'
import * as constants from '@/store/constants'
import { mapGetters } from 'vuex'

import common from '@/mixin/common'
import http from '@/mixin/http'

var COLUMN_COUNT = 5

export default {
  name: 'lessonScore',
  props: {
    productInfo: Object,
  },
  data: function () {
    return {
      unitTitle: this.$store.getters.currentUnit.title,
      path: this.$store.getters.currentPath,
      scores: [],
    }
  },
  computed: {
    ...mapGetters([
      'levelNo',
      'unitNo',
      'lessonIndex',
      'pathIndex',
      'lessonJson',
    ]),
    constants: () => constants,
    COLUMN_COUNT: () => COLUMN_COUNT,
  },
  mixins: [
    common,
    http
  ],
  created: function () {
    if(!this.isEnvironmentPc()) {
      // モバイルアプリの場合
      COLUMN_COUNT = 3
    }

    this.setData()
  },
  mounted: function() {
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  },
  methods: {
    setData: function () {
      var pathsteps = this.path.pathsteps
      var row = []
      for (var pathstep of pathsteps) {
        if (row.length < COLUMN_COUNT) {
          row.push(pathstep)
        } else {
          this.scores.push(row)
          row = []
          row.push(pathstep)
        }
      }
      if (0 < row.length) {
        this.scores.push(row)
      }
    },
    showPathstep: function (pathstepIndex) {
      var self = this
      var apiData = this.createScoreValue()

      this.doSetKeyValue(apiData)
      .then(function(){
        for (var child of self.$parent.$children) {
          if (child.$options.name == "runmode") {
            child.setNextPathstepIndex(pathstepIndex)

            // state更新
            self.log("set LessonState: " + constants.LESSON_STATE_STOP)
            self.$store.dispatch('setLessonState', constants.LESSON_STATE_STOP)
            break
          }
        }
        self.$emit('close')
      })
      .catch(function(message) {
        if(message.length != 0) {
          self.$emit('showError', message, mixinConstants.ERROR_BUTTON_KIND_LOGIN)
        }
      })
    },
    /**
     * スコアのAPI送信用のデータを作成
     */
    createScoreValue: function() {
      // スコアを取得
      var pathstepIndex = this.$store.getters.pathstepIndex
      var pathScore = this.$store.getters.currentPath
      var pathstepScore = pathScore.pathsteps[pathstepIndex]

      // API送信のデータを作成
      var score = this.createScoreDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, pathstepIndex, pathstepScore.ok, pathstepScore.ng, pathstepScore.skip)
      var apiData = '{"data":[' + score + ']}'

      return apiData
    },
    /**
     * key-value設定APIを実行
     */
    doSetKeyValue: function(datajson) {
      var self = this

      return new Promise(function(resolve, reject) {
        // key-value設定API
        self.setKeyValue(self.productInfo.code, datajson)
        .then(function(response) {
          switch (response.result_code) {
            case 'OK':
              resolve()
              break
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message)
              break
            default:
              resolve()
              break
          }
        })
        .catch(function(err) {
          resolve()
        })
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// LessonScore.vue?78f8cfaa